import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import IconText from '#components/a/IconText'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import Modal from '#components/m/Modal'

const DialogDeleteIcon = ({type, gruppenId, subject, onConfirm, id}) => {
  const headerText = () => {
    if (type === 'termin') {
      return i18n.t('termin_loeschen_header')
    }
    if (type === 'ausbilderTermin') {
      if (gruppenId) {
        return i18n.t('versetzungsplan_delete_gruppen_termin_confirmation_headline')
      } else {
        return i18n.t('versetzungsplan_delete_termin_confirmation_headline')
      }
    }
    return i18n.t('abteilung_loeschen_header')
  }

  const bodyText = () => {
    if (type === 'termin') {
      return i18n.t('termin_loeschen_text')
    }
    if (type === 'ausbilderTermin') {
      if (gruppenId) {
        return i18n.t('versetzungsplan_delete_gruppen_termin_confirmation_body', [subject])
      } else {
        return i18n.t('versetzungsplan_delete_termin_confirmation_body', [subject])
      }
    }
    return i18n.t('abteilung_loeschen_text')
  }

  return (
    <div className="terminDelete">
      <Modal
        hasCloseButton
        confirmCallback={onConfirm}
        confirmText={i18n.t('termin_loeschen_buttontext')}
        modifier="narrow"
        trigger={
          <button className="terminDelete__button" type="button">
            <IconText
              id={`deleteTermin_${id}`}
              icon="delete"
              event={() => {}}
              modifier="grey"
              text={i18n.t('taetigkeit_delete')}
            />
          </button>
        }>
        <Headline modifier="article" importance={2} text={headerText()} />
        <Text text={bodyText()} modifier="paragraph" />
      </Modal>
    </div>
  )
}

DialogDeleteIcon.propTypes = {
  id: PropTypes.string,
  onConfirm: PropTypes.func,
  type: PropTypes.oneOf(['termin', 'abteilung', 'ausbilderTermin']),
  gruppenId: PropTypes.string,
  subject: PropTypes.string,
}

export default DialogDeleteIcon
